export default {
    searchDestinataire: function(filename, destinataires) {
        filename = filename.toLowerCase()
        const matches = []
        /* Matching sur nom et prénom simple */
        destinataires.forEach(destinataire => {
            if(!destinataire.nom) {
                destinataire.nom = ""
            }
            if(!destinataire.prenom) {
                destinataire.prenom = ""
            }
            if(filename.includes(destinataire.nom.toLowerCase()) && filename.includes(destinataire.prenom.toLowerCase())) {
                matches.push(destinataire)
            }
        })
        /* Si on a rien trouvé, on fait un matching plus complexe en décomposant le nom prénom en mots */
        if(matches.length === 0) {
            destinataires.forEach(destinataire => {                
                let nomPrenom = ""
                nomPrenom += (destinataire.nom ? destinataire.nom.toLowerCase() : "")
                nomPrenom += (destinataire.prenom ? destinataire.prenom.toLowerCase() : "")
                let wordMatchCount = 0
                nomPrenom.split(" ").forEach(word => {
                    if(word.length > 2 && filename.includes(word)) {
                        wordMatchCount++
                    }
                });
                if(wordMatchCount > 1) {
                    matches.push(destinataire)
                }
            })
        }
        /* Si on a toujours rien trouvé, on fait un matching ultra lache sur juste un mot*/
        if(matches.length === 0) {
            destinataires.forEach(destinataire => {                
                let nomPrenom = ""
                nomPrenom += (destinataire.nom ? destinataire.nom.toLowerCase() : "")
                nomPrenom += (destinataire.prenom ? destinataire.prenom.toLowerCase() : "")
                let wordMatchCount = 0
                nomPrenom.split(" ").forEach(word => {
                    if(word.length > 4 && filename.includes(word)) {
                        wordMatchCount++
                    }
                });
                if(wordMatchCount > 0) {
                    matches.push(destinataire)
                }
            })
        }
        return matches
    }
}